var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardHeader',{attrs:{"title":"Manage Images"}},[_c('ManageImageTiles',{attrs:{"folders":_vm.folders}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }